import { RouteConfig } from 'vue-router'
import { getRouterDomainConfigs } from '@/config/domainRegistry'
import router from '@/config/router/router'

export const getDomainRoutes = async (): Promise<RouteConfig[]> => {
  const routerDomainConfigs = getRouterDomainConfigs()
  return await Promise.all(
    routerDomainConfigs
      .filter(({ routesFactory }) => routesFactory)
      .map(({ routesFactory }) => routesFactory!())
  ).then(routes => routes.reduce((acc, val) => acc.concat(val)))
}

export const addDomainRoutes = async () => {
  const routerConfigs = getRouterDomainConfigs()
  await Promise.all(
    routerConfigs
      .filter(({ routesFactory }) => routesFactory)
      .map(async ({ routesFactory }) => routesFactory!())
  )
    .then(routes => routes.reduce((acc, val) => acc.concat(val)))
    .then(routes => router.addRoutes(routes))
}
